import {APP_INITIALIZER, ErrorHandler, PLATFORM_ID, Provider} from "@angular/core";
import {isPlatformBrowser} from "@angular/common";
import {Router} from "@angular/router";
import * as Sentry from "@sentry/angular-ivy";
import {SentryContextService} from "../services/sentry-context.service";

/**
 * Sentry is initialised in main.ts, which only ever runs in the browser. AppServerModule imports
 * AppModule, so every hook below has to fall back to a no-op during SSR rather than reach for a
 * client that was never created.
 */
export const SENTRY_PROVIDERS: Provider[] = [
  {
    provide: ErrorHandler,
    // eslint-disable-next-line @typescript-eslint/ban-types
    useFactory: (platformId: Object) =>
      isPlatformBrowser(platformId) ? Sentry.createErrorHandler({showDialog: false}) : new ErrorHandler(),
    deps: [PLATFORM_ID]
  },
  {
    provide: Sentry.TraceService,
    // Constructing TraceService is what subscribes it to the router, so the guard belongs here and
    // not on the initializer below: anything listed in an APP_INITIALIZER's deps gets instantiated
    // regardless of platform.
    // eslint-disable-next-line @typescript-eslint/ban-types
    useFactory: (platformId: Object, router: Router) => (isPlatformBrowser(platformId) ? new Sentry.TraceService(router) : null),
    deps: [PLATFORM_ID, Router]
  },
  {
    provide: APP_INITIALIZER,
    useFactory: () => () => {
      return;
    },
    // SentryContextService guards itself, and is listed here purely so something instantiates it.
    deps: [Sentry.TraceService, SentryContextService],
    multi: true
  }
];
